module.exports = __webpack_public_path__ + "img/nunito-sans-v11-latin-600.5946db3b.svg";